import { format as formatFunction } from 'date-fns/esm'
import locale from 'date-fns/locale/nl-BE'
import { formatToTimeZone } from 'date-fns-timezone'

function formatLocale(date: Date | number | string, format: string) {
  return formatFunction(new Date(date), format, { locale })
}

function formatInTZ(date: Date | number | string, format: string) {
  return formatToTimeZone(new Date(date), format, {
    timeZone: 'Europe/Brussels',
  })
}

function capitalize(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export { capitalize, formatInTZ, formatLocale }
